import {createRouter, createWebHistory} from 'vue-router'
import EventsView from '../views/events/EventsView.vue'
import EventView from '../views/events/EventView.vue'
import LoginView from '../views/auth/LoginView.vue'
import UnauthorizedView from '../views/auth/UnauthorizedView.vue';

import {useLayoutsStore} from "@/composables/layouts";
import BaseLayout from "@/layouts/BaseLayout.vue";

const routes = [
    {
        path: "/",
        component: BaseLayout,
        children: [
            {
                path: '/',
                name: 'events',
                component: EventsView,
                meta: {
                    middleware: 'auth'
                }
            },
            {
                path: '/events/:id',
                name: 'event',
                component: EventView,
                props: true,
                meta: {
                    middleware: 'auth'
                }
            },
            {
                path: '/login',
                name: 'login',
                component: LoginView,
            },
            {
                path: '/unauthorized',
                name: 'unauthorized',
                component: UnauthorizedView,
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(() => {
    const layoutStore = useLayoutsStore();
    layoutStore.changeLayout('loader');
});

export default router
